import React from 'react';
import Layout from '../components/Layout';
import LineSeperator from '../components/ui/LineSeperator';
import '../stylings/MessagePage.css';

export default function ManagerMessage() {
  return (
    <Layout bannerTitle="Manager's Message">
      <section className="inner-page-section">
        <div className="container-fluid px-5">
          <LineSeperator title="Message from the Manager" />
          <div className="row g-5 mt-2 align-items-start">
            <div className="col-lg-4 text-center">
              <div className="message-page-photo-wrapper">
                <div className="message-page-photo-placeholder">
                  <i className="fas fa-user-circle"></i>
                </div>
                {/* [PLACEHOLDER: Replace with actual manager photo] */}
                <h4 className="mp-name">School Manager</h4>
                <p className="mp-designation">Manager</p>
                <p className="mp-school">Akash Model Sr. Sec. School</p>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="message-page-content">
                <p className="message-opening">Dear Parents and Students,</p>
                <p>
                  On behalf of the management of Akash Model Sr. Sec. School, I extend a warm
                  welcome to all. Our school has been serving the educational needs of children
                  in the Rohini and Baljeet Vihar area for over 34 years.
                </p>
                <p>
                  We believe every student has unique potential, and our dedicated team of teachers
                  and administrators works tirelessly to provide the best learning environment for all.
                  Our focus is on creating a school community where every child feels valued,
                  supported, and challenged to reach their full potential.
                </p>
                <p>
                  We continuously upgrade our facilities and curriculum to meet the evolving demands
                  of education in the 21st century. From digital literacy to life skills, we prepare
                  our students for a rapidly changing world.
                </p>
                <p className="message-sign-off">Warm regards,</p>
                <div className="message-signature">
                  <strong>School Manager</strong>
                  <span>Manager, Akash Model Sr. Sec. School</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
